import { render, staticRenderFns } from "./SearchPanel.vue?vue&type=template&id=14bd37c4&"
import script from "./SearchPanel.vue?vue&type=script&lang=ts&"
export * from "./SearchPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {StoreSearchInput: require('/app/components/store/SearchInput.vue').default,BaseIcon: require('/app/components/base/Icon.vue').default,StoreOpeningTimes: require('/app/components/store/OpeningTimes.vue').default})
